import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Modal, Form, Input, Button, Popconfirm, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import isEqual from "lodash.isequal";
import CloseButton from "../../../components/Common/CloseButton/CloseButton";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import "./index.css";

const {
  createNewRegion,
  getRegions,
  getReservationTable,
  editReservationRegion,
  deleteReservationRegion,
  getTouchsaleTablesPerRegion,
} = restaurantSchemaActions;

const RestaurantSchema = () => {
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState();
  const [items, setItems] = useState();
  const [openAddZoneModal, setOpenAddZoneModal] = useState(false);
  const [openEditZoneModal, setOpenEditZoneModal] = useState(false);
  const newTabIndex = useRef(0);
  const [form] = Form.useForm();

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  useEffect(() => {
    dispatch(getRegions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEqual(items, regions) || regions.length !== items.length) {
      setActiveKey(regions[0]?.key);
      setItems(regions);
      // Get all Reservation Tables
      dispatch(getReservationTable(regions[0]?.key));

      // Get all Touchsale tables {name: "", id: ""}
      dispatch(
        getTouchsaleTablesPerRegion({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          restaurantId: parseInt(localStorage.getItem("restaurantId")),
          regionId: activeKey,
        })
      );
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regions]);

  const onChange = (newActiveKey) => {
    setActiveKey(newActiveKey);
    // Get all Reservation Tables
    dispatch(getReservationTable(newActiveKey));

    // Get all Touchsale tables {name: "", id: ""}
    dispatch(
      getTouchsaleTablesPerRegion({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        restaurantId: parseInt(localStorage.getItem("restaurantId")),
        regionId: activeKey,
      })
    );
  };

  const addNewZone = () => {
    setOpenAddZoneModal(true);
  };

  const onEdit = (targetKey, action) => {
    if (action === "add") {
      addNewZone();
    }
  };

  const handleOkAddZone = () => {
    form.validateFields().then((values) => {
      const newActiveKey = `newTab${newTabIndex.current++}`;
      const newPanes = [...items];

      dispatch(
        createNewRegion({
          name: values.name,
          organizationId: parseInt(localStorage.getItem("organizationId")),
        })
      );

      setItems(newPanes);
      setActiveKey(newActiveKey);
      setOpenAddZoneModal(false);
      form.resetFields();
    });
  };

  const handleEditZone = () => {
    form.validateFields().then((values) => {
      dispatch(
        editReservationRegion({
          name: values.name,
          regionId: activeKey,
          organizationId: parseInt(localStorage.getItem("organizationId")),
        })
      );

      setOpenEditZoneModal(false);
      form.resetFields();
    });
  };

  const handleDeleteRegion = (e) => {
    dispatch(
      deleteReservationRegion({
        regionId: activeKey,
        organizationId: parseInt(localStorage.getItem("organizationId")),
      })
    );
    setOpenEditZoneModal(false);
    message.success("Успешно изтриване на регион");
    form.resetFields();
  };

  return (
    <>
      <Modal
        closeIcon={<CloseButton />}
        title="Създай Регион"
        open={openAddZoneModal}
        onOk={handleOkAddZone}
        onCancel={() => setOpenAddZoneModal(false)}
        className="reservation-create-zone-modal"
        footer={
          <Button type="primary" onClick={handleOkAddZone}>
            Добави
          </Button>
        }
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Име на региона"
            rules={[
              { required: true, message: "Моля въведете име на региона" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        closeIcon={<CloseButton />}
        title="Промени регион"
        open={openEditZoneModal}
        onOk={handleEditZone}
        onCancel={() => setOpenEditZoneModal(false)}
        className="reservation-edit-zone-modal"
        footer={
          <>
            <Popconfirm
              title="Изтриване на регион"
              description="Сигурни, че искате да изтриете този регион?"
              onConfirm={handleDeleteRegion}
              placement="bottom"
              okText="Изтрий"
              cancelText="Назад"
            >
              <Button danger>Изтрий регион</Button>
            </Popconfirm>
            <Button type="primary" onClick={handleEditZone}>
              Промени
            </Button>
          </>
        }
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Име на зоната"
            rules={[{ required: true, message: "Моля въведете име на зоната" }]}
          >
            <Input
              placeholder={
                items?.find((item) => item.key === activeKey)?.label ||
                "Име на региона"
              }
            />
          </Form.Item>
        </Form>
      </Modal>

      <Tabs
        type="editable-card"
        onChange={onChange}
        activeKey={activeKey}
        onEdit={onEdit}
        items={items}
        tabBarExtraContent={
          <Button
            id="reservations-edit-region-button"
            onClick={() => setOpenEditZoneModal(true)}
          >
            <EditOutlined />
          </Button>
        }
      />
    </>
  );
};
export default RestaurantSchema;
